import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Trans } from 'react-i18next';

import { Icon } from '@/components/Icon/Icon';
import { Page } from '@/components/Layout/Page/Page';

import { getAssetPath } from '@/constants/configs';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { MinorBasicInfoForm } from '@/pages/onboarding/minor-basic-information/components/MinorBasicInfoForm';

import { selectConfigsState } from '@/redux/configs/selectors';
import { selectOperationUser } from '@/redux/operation/selectors';

import { DocumentSection, DocumentType } from '@/types/document';

import { getDataTestId } from '@/utils/browser';
import { findLatestActiveDoc } from '@/utils/document';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

export function MinorBasicInfoPage() {
  const { t, language } = useTranslate();
  const theme = useTheme();
  const minor = useAppSelector(selectOperationUser);
  const isFamilyBook =
    useAppSelector(selectConfigsState).isoCode === 'SUR' &&
    findLatestActiveDoc(minor?.documents ?? [], DocumentSection.Identity)
      ?.docType === DocumentType.FamilyBook;
  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        bgImg: getAssetPath('/bg-register.png'),
        color: theme => theme.palette.overlay.darkBlue.start,
        secondColor: theme => theme.palette.overlay.darkBlue.end,
        hasLogo: true,
        children: (
          <Stack direction="row" justifyContent="center" gap={1.5}>
            <Icon name="lock" color={theme => theme.palette.common.white} />
            <Typography
              variant="caption"
              color={theme.palette.common.white}
              {...getDataTestId('minor-basic-info-page-caption')}
            >
              {t('createNewAccount.basicInfo.caption')}
            </Typography>
          </Stack>
        ),
      }}
      progressProps={isFamilyBook ? undefined : PROGRESS_STEPS.basicInfoStep}
    >
      <Box pb={12}>
        <Trans
          lang={language}
          i18nKey="createNewAccount.basicInfo.minor.bodyDesktop"
          components={{
            br: <br />,
            a1: <Typography variant="h1" mb={6} />,
            a2: (
              <Typography
                variant="h1"
                component="span"
                color={theme.palette.primaries[500]}
              />
            ),
          }}
        />
        <MinorBasicInfoForm />
      </Box>
    </Page>
  );
}

export default MinorBasicInfoPage;
